type LogMethod = (message: any, ...optionalParams: any[]) => void;

type Logger = {
    log: LogMethod;
    warn: LogMethod;
    error: LogMethod;
    info: LogMethod;
}

const createLoggerMethod = (method: 'log' | 'warn' | 'error' | 'info'): LogMethod => {
    return (message, ...optionalParams) => {
        if (process.env.NODE_ENV === "development") {
            console[method](message, ...optionalParams);
        }
    };
};

const log: Logger = {
    log: createLoggerMethod('log'),
    warn: createLoggerMethod('warn'),
    error: createLoggerMethod('error'),
    info: createLoggerMethod('info'),
};

export default log;